
    const data = {"name":"src/core/icons/email-arrow-left","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 19c0-3.31 2.69-6 6-6 1.1 0 2.12.3 3 .81V6a2 2 0 0 0-2-2H4c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h9.09c-.05-.33-.09-.66-.09-1M4 8V6l8 5 8-5v2l-8 5-8-5m14 8v2h4v2h-4v2l-3-3 3-3Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            